import { lazy } from "react";
import CollectDataField from "src/api/graphql/__generated__/enums/CollectDataField";
import { ModalConfig } from "../types";

const LoginContainerModalWrapper = lazy(
	() => import("src/screens/(login)/LoginContainer/LoginContainerModalWrapper"),
);

type LoginModal = {
	LoginContainer: {
		props: {
			title?: string;
			collectData?: CollectDataField[];
		};
	};
};

export default LoginModal;

export const LoginModalConfig = {
	LoginContainer: {
		component: LoginContainerModalWrapper,
		variant: "FullBlur",
	},
} satisfies ModalConfig<LoginModal>;
